import { CartQueryResult } from '@graphql/queries/__generated__/cart.generated'
import React, { useState } from 'react'
import CartLinesTotal from './components/CartLinesTotal'
import { useTranslation } from 'react-i18next'
import WholesaleCartLinesContainer from '@components/WholesaleCartLines/WholesaleCartLinesContainer'
import OrderNoteForm from '@components/Forms/OrderNoteForm'
import { OrderNoteFragment } from '@graphql/fragments/__generated__/OrderNote.generated'
import FormattedDate from '@components/FormattedDate'
import CartPageLayout from '@components/CartPageLayout'

interface PageProps {
  cartQueryResult: CartQueryResult
  orderNotes: OrderNoteFragment[]

  cartClear(categoryId?: string): Promise<void>

  onSaveAsDraft(): Promise<void>

  onCreateOrderNote(values: { orderId: number; content: string; replyToMe: boolean }): Promise<void>

  onDeleteOrder(): void
}

const Page: React.FC<PageProps> = ({
  cartQueryResult,
  orderNotes,
  cartClear,
  onSaveAsDraft,
  onCreateOrderNote,
  onDeleteOrder,
}) => {
  const { t } = useTranslation()
  const [isNoteFormShow, setIsNoteFormShow] = useState(false)
  const onAddNote = () => {
    setIsNoteFormShow(true)
  }
  const orderId = cartQueryResult.data?.cart?.orderId
  return (
    <CartPageLayout
      lines={<WholesaleCartLinesContainer />}
      sidebar={
        <>
          <CartLinesTotal
            cartQueryResult={cartQueryResult}
            loading={cartQueryResult.loading}
            onSaveAsDraft={onSaveAsDraft}
            onAddNote={onAddNote}
            onDeleteOrder={onDeleteOrder}
            cartClear={cartClear}
          />
          {orderId && isNoteFormShow && (
            <OrderNoteForm
              onSubmit={async values => {
                setIsNoteFormShow(false)
                await onCreateOrderNote({ orderId, ...values })
              }}
              onCancel={() => setIsNoteFormShow(false)}
            />
          )}
          {!!orderNotes.length && (
            <div className='mt-10 bg-white shadow-card rounded-lg p-10'>
              <p className='text-bold text-base'>{t('title.notes', 'Notes')}</p>
              {orderNotes.map(node => (
                <div key={node.id} className='pb-10 text-gray text-sm'>
                  <div>
                    {node.creator} - <FormattedDate value={node.date} variant='long' />
                  </div>
                  <pre style={{ fontFamily: 'inherit', margin: 0 }}>{node.content}</pre>
                </div>
              ))}
            </div>
          )}
        </>
      }
    />
  )
}

export default Page
